/**
 * utils/sidebarPrefs.js
 * Standalone localStorage persistence for the sidebar's collapsed/expanded UI state — kept
 * deliberately separate from storage.js's STORAGE_KEY/NORM_VERSION/migrateData machinery,
 * since this is pure UI chrome with zero business significance, not app data.
 */
export const SIDEBAR_COLLAPSED_KEY = "bukukas2_sidebar_collapsed";

export function loadSidebarCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
  } catch {
    return false; // default: expanded
  }
}

export function saveSidebarCollapsed(collapsed) {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "true" : "false");
  } catch {
    // quota/private-mode failure — collapse state is decorative, never block the UI
  }
}
